<template>
  <div class="row main-content">
    <div class="col">
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <h1 class="page-title font-custom text-uppercase mt-3">
          {{ $t("title.product.detail") }}
        </h1>

        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t("error." + `${responseErr}`) }}
          </strong>
        </div>

        <template v-if="$store.state.products.productDetail && hasPermission('product:create')">
          <div
            class="card-body bg-light mb-4 d-flex"
          >
            <button
              type="button"
              class="base-button font-custom rounded-pill btn btn-primary font-inverted btn-export m-1"
              @click="showEdit($store.state.products.product)"
            >
              {{ $t("button.edit") }}
            </button>
            <button
              type="button"
              class="base-button font-custom rounded-pill btn btn-outline-secondary border-secondary btn-export m-1"
              @click="showCreate($store.state.products.product)"
            >
              {{ $t("button.copy") }}
            </button>
            <button
              type="button"
              class="base-button font-custom rounded-pill btn btn-primary btn-export ms-auto"
              @click="exportProduct($store.state.products.productDetail)"
            >
              {{ $t("button.export") }}
            </button>
          </div>
        </template>

        <div v-if="$store.state.products.productDetail">
          <div
            v-for="productDescription in $store.state.products.productDetail"
            :id="'accordion' + productDescription.code"
            :key="productDescription.id"
            class="card rounded-0 mb-4"
          >
            <div
              :id="'heading' + productDescription.code"
              data-bs-toggle="collapse"
              :data-bs-target="'#collapse' + productDescription.code"
              aria-expanded="false"
              :aria-controls="'collapse' + productDescription.code"
              class="card-header font-accent fw-bold"
            >
              {{ productDescription.code }} :
              {{ productDescription.description }}
            </div>
            <div
              :id="'collapse' + productDescription.code"
              :aria-labelledby="'heading' + productDescription.code"
              :data-bs-parent="'#accordion' + productDescription.code"
              class="card-body collapse"
            >
              <div
                v-for="param in productDescription.params"
                :key="param.code"
                class="row p-1"
              >
                <div
                  class="col-3 text-end"
                  style="padding-right: 4px;"
                >
                  <strong>
                    {{ param.code }} :
                  </strong>
                </div>
                <div
                  class="col-3"
                  style="padding-left: 0; font-style: italic;"
                >
                  <span>{{ param.description }}</span>
                </div>
                <div class="col">
                  <div
                    v-for="value in param.value"
                    :key="value.id"
                  >
                    {{ value }} <br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <goTopButton />
    <div
      id="copyModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="copyModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="copyModalLabel"
              class="modal-title"
            >
              {{ $t('label.modal.COPY_MODAL_LABEL') }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body">
            <div class="alert alert-info">
              <p>
                {{ $t('label.modal.COPY_MODAL_MSG') }}
              </p>
            </div>
            <textarea
              id="copyModalText"
              class="form-control"
              rows="5"
              readonly="readonly"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./ProductDetail.js"></script>

<style src="./ProductDetail.scss" scoped lang="scss"></style>
